var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import errorCoverImage from "././assets/error-icon.svg";
var MASONRY_WIDGET_ASSETS_MAP = {
  ERROR_STATE_COVER: errorCoverImage
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(MASONRY_WIDGET_ASSETS_MAP);
};

// src/components/large-visual-card-widget/large-visual-card-widget.component.tsx
import React7, { useRef } from "react";

// src/components/common/large-image-card/large-image-card.component.tsx
import React3 from "react";
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";

// src/components/common/vertical-large-image-card/vertical-large-image-card.component.tsx
import React from "react";
import { StackLayout } from "@leagueplatform/genesis-core";

// src/components/common/common.tsx
import { css, genesisStyled, Image } from "@leagueplatform/genesis-commons";
var StyledImg = genesisStyled(Image)(
  css({
    objectFit: "cover"
  })
);

// src/components/common/vertical-large-image-card/vertical-large-image-card.component.tsx
var VerticalLargeImageCard = ({
  image,
  imageAltText,
  children
}) => /* @__PURE__ */ React.createElement(
  StackLayout,
  {
    orientation: "vertical",
    verticalAlignment: "spaceBetween",
    horizontalAlignment: "stretch",
    spacing: "$none"
  },
  /* @__PURE__ */ React.createElement(
    StyledImg,
    {
      borderTopRightRadius: "medium",
      borderTopLeftRadius: "medium",
      borderStyle: "solid",
      src: image,
      width: "100%",
      height: "176px",
      alt: imageAltText
    }
  ),
  children
);

// src/components/common/horizontal-large-image-card/horizontal-large-image-card.component.tsx
import React2 from "react";
import { StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";
var HorizontalLargeImageCard = ({
  image,
  imageAltText,
  children,
  imageAlign = "left"
}) => {
  const isImageAlignLeft = imageAlign === "left";
  return /* @__PURE__ */ React2.createElement(
    StackLayout2,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      spacing: "$oneAndHalf",
      verticalAlignment: "center",
      css: {
        flexFlow: isImageAlignLeft ? "row-reverse" : "row"
      }
    },
    children,
    /* @__PURE__ */ React2.createElement(
      StyledImg,
      {
        borderTopLeftRadius: isImageAlignLeft && "medium",
        borderBottomLeftRadius: isImageAlignLeft && "medium",
        borderTopRightRadius: !isImageAlignLeft && "medium",
        borderBottomRightRadius: !isImageAlignLeft && "medium",
        borderStyle: "solid",
        src: image,
        width: "350px",
        minHeight: "176px",
        height: "100%",
        alt: imageAltText
      }
    )
  );
};

// src/components/common/large-image-card/large-image-card.component.tsx
var LargeImageCard = ({
  image,
  imageAltText = "",
  isChildItem = false,
  imageAlign,
  children
}) => {
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const CardComponent = isMobile || isChildItem ? VerticalLargeImageCard : HorizontalLargeImageCard;
  return /* @__PURE__ */ React3.createElement(
    CardComponent,
    {
      image,
      imageAltText,
      imageAlign
    },
    children
  );
};

// src/components/large-visual-card-widget/large-visual-card-widget.component.tsx
import { ConditionalLinkCard } from "@leagueplatform/web-common-components";

// src/components/large-visual-card-widget/large-visual-card-content.component.tsx
import React6 from "react";
import {
  Box,
  HeadingThree,
  Overline,
  SubtitleOne,
  Text
} from "@leagueplatform/genesis-commons";

// src/components/common/badge-list/badge-list.component.tsx
import * as React5 from "react";
import {
  UtilityText,
  StackLayout as StackLayout4,
  Icon
} from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";

// src/components/common/badge-pill/badge-pill.component.tsx
import React4 from "react";
import { StackLayout as StackLayout3 } from "@leagueplatform/genesis-core";
var BadgePill = ({
  children,
  backgroundColor = "$decorativeBrandSecondaryBright"
}) => /* @__PURE__ */ React4.createElement(
  StackLayout3,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$quarter",
    css: {
      flex: "0 0 auto",
      borderStyle: "$solid",
      borderRadius: "$pill",
      paddingInline: "$half",
      paddingBlock: "$quarter",
      width: "fit-content",
      backgroundColor
    }
  },
  children
);

// src/components/common/badge-list/badge-list.component.tsx
var BadgeList = ({ badges, backgroundColor }) => /* @__PURE__ */ React5.createElement(
  StackLayout4,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$threeQuarters",
    css: {
      flexWrap: "wrap"
    }
  },
  badges == null ? void 0 : badges.map(({ image, imageAltText, body }) => /* @__PURE__ */ React5.createElement(BadgePill, { key: uniqueId(), backgroundColor }, image && /* @__PURE__ */ React5.createElement(Icon, { icon: image, label: imageAltText, size: "$threeQuarters" }), body && /* @__PURE__ */ React5.createElement(
    UtilityText,
    {
      emphasis: "emphasized",
      size: "sm",
      css: {
        color: "$onSurfaceTextPrimary",
        textAlign: "center"
      }
    },
    body
  )))
);

// src/components/large-visual-card-widget/large-visual-card-content.component.tsx
import { ConditionalLink } from "@leagueplatform/web-common-components";
import { ParagraphText, StackLayout as StackLayout5 } from "@leagueplatform/genesis-core";

// src/utils/body-text-html-tag-options.ts
import { TextAction } from "@leagueplatform/genesis-core";
import { InternalOrExternalLinkButton } from "@leagueplatform/web-common-components";
var BodyTextHtmlTagOptions = {
  a: {
    component: InternalOrExternalLinkButton,
    props: {
      baseComponent: TextAction,
      // Stop event propagation to prevent triggering on card click event on click of link inside paragraph text
      onClick: (e) => e.stopPropagation()
    }
  }
};

// src/components/large-visual-card-widget/large-visual-card-content.component.tsx
var LargeVisualCardContent = ({
  overline,
  linkRefState,
  linkUrl,
  title,
  description,
  badges,
  onCardClick
}) => {
  const overlineId = `lvc-${title.replace(/\s+/g, "-")}`;
  return /* @__PURE__ */ React6.createElement(
    StackLayout5,
    {
      spacing: "$half",
      orientation: "vertical",
      css: {
        padding: "$oneAndHalf"
      }
    },
    overline && /* @__PURE__ */ React6.createElement(Overline, { as: Text, id: overlineId, color: "onSurface.text.subdued" }, overline),
    /* @__PURE__ */ React6.createElement(StackLayout5, { spacing: "$quarter", orientation: "vertical" }, /* @__PURE__ */ React6.createElement(
      SubtitleOne,
      {
        as: HeadingThree,
        "aria-describedby": overlineId,
        fontWeight: "bold"
      },
      /* @__PURE__ */ React6.createElement(
        ConditionalLink,
        {
          ref: linkRefState,
          url: linkUrl,
          onClick: onCardClick
        },
        title
      )
    ), /* @__PURE__ */ React6.createElement(ParagraphText, { htmlStringOptions: BodyTextHtmlTagOptions }, description)),
    badges && /* @__PURE__ */ React6.createElement(Box, { marginTop: "threeQuarters" }, /* @__PURE__ */ React6.createElement(BadgeList, { badges }))
  );
};

// src/components/large-visual-card-widget/large-visual-card-widget.component.tsx
var LargeVisualCardWidget = (_a) => {
  var _b = _a, {
    isChildItem,
    image,
    imageAltText,
    linkUrl
  } = _b, props = __objRest(_b, [
    "isChildItem",
    "image",
    "imageAltText",
    "linkUrl"
  ]);
  const linkRefState = useRef(null);
  return /* @__PURE__ */ React7.createElement(ConditionalLinkCard, { linkRef: linkRefState, hasLink: Boolean(linkUrl) }, /* @__PURE__ */ React7.createElement(
    LargeImageCard,
    {
      imageAlign: "right",
      image,
      imageAltText,
      isChildItem
    },
    /* @__PURE__ */ React7.createElement(
      LargeVisualCardContent,
      __spreadValues({
        linkUrl,
        linkRefState
      }, props)
    )
  ));
};

// src/components/text-cta-card-widget/text-cta-card-widget.component.tsx
import React9 from "react";
import {
  PrimaryButton,
  genesisStyled as genesisStyled3
} from "@leagueplatform/genesis-commons";
import {
  HeadingText,
  UtilityText as UtilityText2,
  ParagraphText as ParagraphText2,
  queryHelpers as queryHelpers2,
  StackLayout as StackLayout6,
  useMediaQuery as useMediaQuery2
} from "@leagueplatform/genesis-core";
import { isAbsoluteUrl } from "@leagueplatform/web-common";
import {
  InternalOrExternalLink,
  ConditionalLinkCard as ConditionalLinkCard2
} from "@leagueplatform/web-common-components";

// src/components/square-image-container/square-image-container.component.tsx
import * as React8 from "react";
import {
  Flex,
  genesisStyled as genesisStyled2,
  Image as Image2,
  css as css2
} from "@leagueplatform/genesis-commons";
var StyledImgContainer = genesisStyled2(Flex)(
  ({ theme, maxWidth, maxWidthDesktop }) => css2({
    borderRadius: "medium",
    maxHeight: maxWidth,
    maxWidth,
    aspectRatio: "1 / 1",
    flex: 1,
    overflow: "hidden",
    [`@media screen and (min-width: ${theme.breakpoints.tablet})`]: {
      maxHeight: maxWidthDesktop,
      maxWidth: maxWidthDesktop
    }
  })
);
var StyledImg2 = genesisStyled2(Image2)(
  () => css2({
    width: "100%",
    height: "100%",
    objectFit: "cover"
  })
);
var SquareImageContainer = ({
  src,
  maxWidth,
  maxWidthDesktop,
  alt
}) => /* @__PURE__ */ React8.createElement(StyledImgContainer, { maxWidth, maxWidthDesktop }, /* @__PURE__ */ React8.createElement(StyledImg2, { src, alt }));

// src/components/text-cta-card-widget/text-cta-card-widget.component.tsx
var StyledButton = genesisStyled3(PrimaryButton)`
  text-decoration: none !important;
  text-align: center;
`;
var TextAndCTACardWidget = ({
  title,
  description,
  buttonText,
  linkUrl = "",
  image,
  imageAltText = "",
  isThinWidth = false,
  isChildItem = false,
  onCardClick = () => {
  },
  backgroundColor = "surface.background.tertiary",
  eyebrow
}) => {
  const isExternalUrl = isAbsoluteUrl(linkUrl);
  const isMobile = useMediaQuery2(queryHelpers2.only("mobile"));
  const showSmallerCard = isMobile || isChildItem || isThinWidth;
  return /* @__PURE__ */ React9.createElement(
    ConditionalLinkCard2,
    {
      cardStyle: {
        padding: "oneAndHalf",
        flexDirection: "column",
        backgroundColor
      }
    },
    /* @__PURE__ */ React9.createElement(
      StackLayout6,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: {
          "@mobile": "$threeQuarters",
          "@initial": showSmallerCard ? "$threeQuarters" : "$oneAndHalf"
        }
      },
      /* @__PURE__ */ React9.createElement(StackLayout6, { orientation: "vertical", spacing: "$quarter" }, eyebrow && /* @__PURE__ */ React9.createElement(UtilityText2, { size: "eyebrow" }, eyebrow), /* @__PURE__ */ React9.createElement(HeadingText, { level: "3", size: "sm" }, title), /* @__PURE__ */ React9.createElement(ParagraphText2, { htmlStringOptions: BodyTextHtmlTagOptions }, description), !showSmallerCard && /* @__PURE__ */ React9.createElement(
        StyledButton,
        {
          paddingY: "half",
          as: InternalOrExternalLink,
          isExternalUrl,
          href: linkUrl,
          marginTop: "one",
          onClick: onCardClick
        },
        buttonText
      )),
      image && /* @__PURE__ */ React9.createElement(
        SquareImageContainer,
        {
          src: image,
          alt: imageAltText,
          maxWidth: "8rem",
          maxWidthDesktop: isChildItem ? "8rem" : "11.2rem"
        }
      )
    ),
    showSmallerCard && /* @__PURE__ */ React9.createElement(
      StyledButton,
      {
        width: "100%",
        paddingY: "half",
        as: InternalOrExternalLink,
        isExternalUrl,
        href: linkUrl,
        marginTop: "one",
        onClick: onCardClick
      },
      buttonText
    )
  );
};

// src/components/xsvisual-card-widget/xsvisual-card-widget.component.tsx
import React10, { useRef as useRef2 } from "react";
import {
  css as css3,
  Flex as Flex2,
  genesisStyled as genesisStyled4,
  SubtitleOne as SubtitleOne2,
  Image as Image3,
  HeadingThree as HeadingThree2
} from "@leagueplatform/genesis-commons";
import {
  StackLayout as StackLayout7,
  ConditionalLinkCard as ConditionalLinkCard3,
  ConditionalLink as ConditionalLink2
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText3 } from "@leagueplatform/genesis-core";
var StyledImage = genesisStyled4(Image3)(
  css3({
    contentFit: "cover",
    contentPosition: "center",
    width: "42px",
    height: "42px"
  })
);
var XSVisualCardWidget = ({
  heading,
  image,
  body,
  actionLink,
  imageAltText,
  backgroundColor = "surface.background.primary",
  onCardClick = () => {
  }
}) => {
  const linkRef = useRef2(null);
  return /* @__PURE__ */ React10.createElement(
    ConditionalLinkCard3,
    {
      linkRef,
      hasLink: Boolean(actionLink),
      cardStyle: {
        padding: "oneAndHalf",
        alignItems: "center",
        backgroundColor
      }
    },
    image && /* @__PURE__ */ React10.createElement(Flex2, { marginRight: "threeQuarters", justifyContent: "center" }, /* @__PURE__ */ React10.createElement(StyledImage, { src: image, alt: imageAltText })),
    /* @__PURE__ */ React10.createElement(StackLayout7, { space: "$quarter" }, /* @__PURE__ */ React10.createElement(SubtitleOne2, { as: HeadingThree2, fontWeight: "bold" }, /* @__PURE__ */ React10.createElement(ConditionalLink2, { ref: linkRef, onClick: onCardClick, url: actionLink }, heading)), body && /* @__PURE__ */ React10.createElement(ParagraphText3, { htmlStringOptions: BodyTextHtmlTagOptions }, body))
  );
};

// src/components/carousel-content-card-widget/carousel-content-card-widget.component.tsx
import React11, { useRef as useRef3 } from "react";
import {
  Image as Image4,
  SubtitleOne as SubtitleOne3,
  Caption,
  SubtitleTwo,
  Box as Box2,
  HeadingThree as HeadingThree3,
  Text as Text2
} from "@leagueplatform/genesis-commons";
import {
  StackLayout as StackLayout8,
  ConditionalLinkCard as ConditionalLinkCard4,
  ConditionalLink as ConditionalLink3
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText4 } from "@leagueplatform/genesis-core";

// src/constants.ts
var COMPLEX_WIDGET_CARDS_WIDTH = "275px";
var CAROUSEL_CONTENT_CARD_WIDTH = "282px";

// src/components/carousel-content-card-widget/carousel-content-card-widget.component.tsx
var CarouselContentCardWidget = ({
  title,
  overline,
  description,
  imageAltText,
  badge,
  badgeImage,
  image,
  linkUrl,
  onClick
}) => {
  const linkRef = useRef3(null);
  const overlineId = `cc-${title.replace(/\s+/g, "-")}`;
  return /* @__PURE__ */ React11.createElement(
    ConditionalLinkCard4,
    {
      linkRef,
      hasLink: Boolean(linkUrl),
      cardStyle: {
        width: CAROUSEL_CONTENT_CARD_WIDTH,
        flexDirection: "column",
        height: "100%"
      }
    },
    /* @__PURE__ */ React11.createElement(
      Image4,
      {
        src: image,
        alt: imageAltText,
        css: { width: "100%", height: "176px", objectFit: "cover" },
        borderTopLeftRadius: "medium",
        borderTopRightRadius: "medium",
        backgroundColor: "surface.background.secondary"
      }
    ),
    /* @__PURE__ */ React11.createElement(Box2, { margin: "oneAndHalf" }, /* @__PURE__ */ React11.createElement(StackLayout8, { space: "$half", css: { textAlign: "left" } }, /* @__PURE__ */ React11.createElement(
      SubtitleOne3,
      {
        as: HeadingThree3,
        "aria-describedby": overlineId,
        fontWeight: "bold"
      },
      /* @__PURE__ */ React11.createElement(ConditionalLink3, { ref: linkRef, url: linkUrl, onClick }, title)
    ), overline && /* @__PURE__ */ React11.createElement(Caption, { id: overlineId }, overline), description && /* @__PURE__ */ React11.createElement(ParagraphText4, { htmlStringOptions: BodyTextHtmlTagOptions }, description)), badge && /* @__PURE__ */ React11.createElement(BadgePill, null, badgeImage && /* @__PURE__ */ React11.createElement(
      Image4,
      {
        src: badgeImage,
        alt: "",
        width: "2rem",
        height: "2rem",
        marginRight: "half"
      }
    ), /* @__PURE__ */ React11.createElement(
      SubtitleTwo,
      {
        as: Text2,
        color: "onSurface.text.primary",
        textAlign: "center"
      },
      badge
    )))
  );
};

// src/components/small-visual-card-widget/small-visual-card-widget.component.tsx
import React12, { useRef as useRef4 } from "react";
import {
  Flex as Flex3,
  Overline as Overline2,
  SubtitleOne as SubtitleOne4,
  HeadingThree as HeadingThree4,
  Text as Text3,
  Box as Box3
} from "@leagueplatform/genesis-commons";
import {
  StackLayout as StackLayout9,
  ConditionalLinkCard as ConditionalLinkCard5,
  ConditionalLink as ConditionalLink4
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText5 } from "@leagueplatform/genesis-core";
var SmallVisualCardWidget = ({
  overline,
  title,
  description,
  image,
  badges,
  badgeBackgroundColor,
  imageAltText,
  linkUrl,
  isChildItem = false,
  onCardClick = () => {
  }
}) => {
  const linkRef = useRef4(null);
  const overlineId = `svc-${title.replace(/\s+/g, "-")}`;
  return /* @__PURE__ */ React12.createElement(
    ConditionalLinkCard5,
    {
      linkRef,
      hasLink: Boolean(linkUrl),
      cardStyle: {
        flexWrap: "wrap",
        justifyContent: "space-between",
        padding: "oneAndHalf"
      }
    },
    /* @__PURE__ */ React12.createElement(
      Flex3,
      {
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: isChildItem ? "flex-start" : "center",
        flex: "2"
      },
      /* @__PURE__ */ React12.createElement(StackLayout9, { space: "$half" }, overline && /* @__PURE__ */ React12.createElement(Overline2, { id: overlineId, as: Text3, color: "onSurface.text.subdued" }, overline), /* @__PURE__ */ React12.createElement(StackLayout9, { space: "$quarter" }, /* @__PURE__ */ React12.createElement(
        SubtitleOne4,
        {
          as: HeadingThree4,
          fontWeight: "bold",
          "aria-describedby": overlineId
        },
        /* @__PURE__ */ React12.createElement(
          ConditionalLink4,
          {
            ref: linkRef,
            url: linkUrl,
            onClick: onCardClick
          },
          title
        )
      ), /* @__PURE__ */ React12.createElement(ParagraphText5, { htmlStringOptions: BodyTextHtmlTagOptions }, description))),
      badges && /* @__PURE__ */ React12.createElement(Box3, { marginTop: "threeQuarters" }, /* @__PURE__ */ React12.createElement(BadgeList, { badges, backgroundColor: badgeBackgroundColor }))
    ),
    /* @__PURE__ */ React12.createElement(
      Flex3,
      {
        alignItems: "center",
        justifyContent: "flex-end",
        marginLeft: {
          _: "threeQuarters",
          desktop: "two"
        }
      },
      /* @__PURE__ */ React12.createElement(
        SquareImageContainer,
        {
          src: image,
          alt: imageAltText,
          maxWidth: "9.8rem",
          maxWidthDesktop: isChildItem ? "9.8rem" : "11.2rem"
        }
      )
    )
  );
};

// src/components/notification-banner-widget/notification-banner-widget.component.tsx
import React14 from "react";
import {
  Card as Card2,
  useClickableCard,
  StackLayout as StackLayout11,
  StackItem as StackItem2,
  Button,
  useThemeStrings
} from "@leagueplatform/genesis-core";

// src/components/notification-banner-widget/notification-banner-content.tsx
import React13, { forwardRef } from "react";
import {
  Card,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout10,
  StackItem,
  HeadingText as HeadingText2,
  Box as Box4
} from "@leagueplatform/genesis-core";
var HeadingElement = forwardRef(
  ({ children, url, onCardClick }, ref) => {
    if (url)
      return /* @__PURE__ */ React13.createElement(
        Box4,
        {
          as: "a",
          onClick: onCardClick,
          href: url,
          ref,
          css: {
            "&&": { color: "$onSurfaceTextPrimary", textDecoration: "none" }
          }
        },
        children
      );
    if (onCardClick)
      return /* @__PURE__ */ React13.createElement(
        Box4,
        {
          as: "button",
          ref,
          type: "button",
          onClick: onCardClick,
          css: {
            "&&": {
              color: "$onSurfaceTextPrimary",
              border: "none",
              typography: "$subtitleOne",
              background: "none",
              padding: 0
            }
          }
        },
        children
      );
    return /* @__PURE__ */ React13.createElement("span", null, children);
  }
);
var NotificationBannerContent = forwardRef(
  ({
    image,
    imageAltText,
    heading,
    body,
    url,
    onCardClick
  }, ref) => /* @__PURE__ */ React13.createElement(React13.Fragment, null, image && /* @__PURE__ */ React13.createElement(StackItem, { verticalAlignment: "center" }, /* @__PURE__ */ React13.createElement(
    Card.Image,
    {
      image,
      imageAlt: imageAltText,
      css: {
        width: "$twoAndHalf",
        height: "$twoAndHalf"
      }
    }
  )), /* @__PURE__ */ React13.createElement(StackLayout10, { spacing: "$quarter" }, /* @__PURE__ */ React13.createElement(HeadingText2, { size: "sm", level: "2" }, /* @__PURE__ */ React13.createElement(HeadingElement, { url, onCardClick, ref }, heading)), /* @__PURE__ */ React13.createElement(
    ParagraphText6,
    {
      emphasis: "subtle",
      htmlStringOptions: BodyTextHtmlTagOptions
    },
    body
  )))
);

// src/components/notification-banner-widget/notification-banner-widget.component.tsx
var NotificationBannerWidget = ({
  heading,
  image,
  body,
  url,
  imageAltText,
  dismissible,
  onDismiss,
  onCardClick
}) => {
  const strings = useThemeStrings();
  const isClickable = !!(url || onCardClick);
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  return /* @__PURE__ */ React14.createElement(Card2.Elevated, null, /* @__PURE__ */ React14.createElement(StackLayout11, { orientation: "horizontal", verticalAlignment: "stretch" }, isClickable ? /* @__PURE__ */ React14.createElement(
    Card2.ClickArea,
    {
      css: {
        display: "flex",
        flexDirection: "row",
        gap: "$one",
        padding: "$threeQuarters",
        paddingRight: "$half"
      },
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown
    },
    /* @__PURE__ */ React14.createElement(
      NotificationBannerContent,
      {
        image,
        imageAltText,
        heading,
        body,
        url,
        onCardClick,
        ref: primaryActionRef
      }
    )
  ) : /* @__PURE__ */ React14.createElement(
    StackLayout11,
    {
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$one",
      css: {
        padding: "$threeQuarters",
        paddingRight: "$half"
      }
    },
    /* @__PURE__ */ React14.createElement(
      NotificationBannerContent,
      {
        image,
        imageAltText,
        heading,
        body
      }
    )
  ), dismissible && /* @__PURE__ */ React14.createElement(
    StackItem2,
    {
      verticalAlignment: "top",
      css: { padding: "$threeQuarters", paddingLeft: "$half" }
    },
    /* @__PURE__ */ React14.createElement(
      Button,
      {
        hideLabel: true,
        size: "small",
        icon: "tinyClose",
        priority: "tertiary",
        quiet: true,
        onClick: onDismiss
      },
      strings.dismiss
    )
  )));
};

// src/components/notification-card-widget/notification-card-widget.component.tsx
import React16 from "react";
import {
  Card as Card3,
  useClickableCard as useClickableCard2,
  StackLayout as StackLayout13,
  Icon as Icon2,
  Box as Box6
} from "@leagueplatform/genesis-core";

// src/components/notification-card-widget/notification-card-content.component.tsx
import React15, { forwardRef as forwardRef2 } from "react";
import {
  ParagraphText as ParagraphText7,
  StackLayout as StackLayout12,
  HeadingText as HeadingText3,
  Box as Box5,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";
var eyebrowStyles = {
  borderRadius: "$medium",
  backgroundColor: "$surfaceBackgroundTertiary",
  padding: "$quarter $half",
  marginBottom: "$half"
};
var HeadingLink = forwardRef2(({ children, url, onCardClick }, ref) => {
  if (url)
    return /* @__PURE__ */ React15.createElement(
      Box5,
      {
        as: "a",
        onClick: onCardClick,
        href: url,
        ref,
        css: {
          "&&": { color: "$onSurfaceTextPrimary", textDecoration: "none" }
        }
      },
      children
    );
  if (onCardClick)
    return /* @__PURE__ */ React15.createElement(
      Box5,
      {
        as: "button",
        ref,
        type: "button",
        onClick: onCardClick,
        css: {
          "&&": {
            color: "$onSurfaceTextPrimary",
            border: "none",
            typography: "$subtitleOne",
            background: "none",
            padding: 0,
            cursor: "pointer"
          }
        }
      },
      children
    );
  return /* @__PURE__ */ React15.createElement("span", null, children);
});
var NotificationCardContent = forwardRef2(({ heading, subheading, info, eyebrow, url, onCardClick }, ref) => /* @__PURE__ */ React15.createElement(StackLayout12, null, eyebrow && /* @__PURE__ */ React15.createElement(UtilityText3, { css: eyebrowStyles, size: "eyebrow", emphasis: "emphasized" }, eyebrow), heading && /* @__PURE__ */ React15.createElement(HeadingLink, { onCardClick, url, ref }, /* @__PURE__ */ React15.createElement(HeadingText3, { size: "sm", level: "2", css: { cursor: "inherit" } }, heading)), subheading && /* @__PURE__ */ React15.createElement(
  ParagraphText7,
  {
    css: { "&:not(:last-child)": { marginBlockEnd: 0 } },
    htmlStringOptions: BodyTextHtmlTagOptions
  },
  subheading
), info && /* @__PURE__ */ React15.createElement(
  ParagraphText7,
  {
    emphasis: "subtle",
    size: "sm",
    htmlStringOptions: BodyTextHtmlTagOptions
  },
  info
)));

// src/components/notification-card-widget/notification-card-widget.component.tsx
var clickableCardStyles = {
  display: "flex",
  flexDirection: "row",
  gap: "$one",
  padding: "$one",
  paddingRight: "$quarter",
  alignItems: "center"
};
var NotificationCardWidget = ({
  heading,
  subheading,
  info,
  url,
  eyebrow,
  onCardClick
}) => {
  const isClickable = Boolean(url || onCardClick);
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard2();
  return /* @__PURE__ */ React16.createElement(Card3.Elevated, { backgroundColor: "secondary" }, /* @__PURE__ */ React16.createElement(StackLayout13, { orientation: "horizontal", verticalAlignment: "stretch" }, isClickable ? /* @__PURE__ */ React16.createElement(
    Card3.ClickArea,
    {
      css: clickableCardStyles,
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown
    },
    /* @__PURE__ */ React16.createElement(
      NotificationCardContent,
      {
        heading,
        subheading,
        info,
        eyebrow,
        url,
        onCardClick,
        ref: primaryActionRef
      }
    ),
    isClickable && /* @__PURE__ */ React16.createElement(Icon2, { icon: "interfaceChevronRight" })
  ) : /* @__PURE__ */ React16.createElement(Box6, { css: { padding: "$one" } }, /* @__PURE__ */ React16.createElement(
    NotificationCardContent,
    {
      heading,
      subheading,
      info,
      eyebrow,
      url,
      onCardClick,
      ref: primaryActionRef
    }
  ))));
};

// src/components/welcome-banner/welcome-banner.component.tsx
import React17 from "react";
import {
  Flex as Flex4,
  HeadingOne,
  BodyOneSecondary
} from "@leagueplatform/genesis-commons";
import { PageHeaderBackground } from "@leagueplatform/web-common-components";
var WelcomeBanner = ({ heading, subheading }) => /* @__PURE__ */ React17.createElement(PageHeaderBackground, null, /* @__PURE__ */ React17.createElement(Flex4, { align: "center", width: "100%", mt: 0 }, /* @__PURE__ */ React17.createElement(Flex4, { flexDirection: "column" }, /* @__PURE__ */ React17.createElement(HeadingOne, { textAlign: "left", marginTop: "oneAndHalf" }, heading), subheading && /* @__PURE__ */ React17.createElement(BodyOneSecondary, { marginTop: "threeQuarters" }, subheading))));

// src/components/image-footer/image-footer.component.tsx
import React18 from "react";
import { ImageMessage } from "@leagueplatform/genesis-core";
var ImageAlignMap = /* @__PURE__ */ ((ImageAlignMap2) => {
  ImageAlignMap2["left"] = "start";
  ImageAlignMap2["center"] = "center";
  ImageAlignMap2["right"] = "end";
  return ImageAlignMap2;
})(ImageAlignMap || {});
var ImageFooter = ({
  imageUrl,
  imageAltText,
  imageHeight = 50,
  imageAlign = "center"
}) => /* @__PURE__ */ React18.createElement(
  ImageMessage,
  {
    image: imageUrl,
    imageAlt: imageAltText,
    imageHeight,
    imageHorizontalAlignment: ImageAlignMap[imageAlign]
  }
);

// src/components/hero-banner/hero-banner.component.tsx
import React20, { useRef as useRef5, useState, useEffect, useLayoutEffect } from "react";
import {
  HeadingText as HeadingText4,
  ParagraphText as ParagraphText8,
  StackItem as StackItem4,
  StackLayout as StackLayout14,
  UtilityText as UtilityText4,
  VisuallyHidden,
  queryHelpers as queryHelpers3,
  useMediaQuery as useMediaQuery3,
  styled
} from "@leagueplatform/genesis-core";
import { normalizeInternalUrl } from "@leagueplatform/web-common";

// src/components/common/page-header-background/page-header-background.tsx
import React19 from "react";
import { useUiConfig } from "@leagueplatform/ui-config";
import { StackItem as StackItem3, useTheme } from "@leagueplatform/genesis-core";
import { get } from "lodash";
var DEFAULT_STYLES = {
  height: "140px",
  width: "20024px",
  smallScreenWidth: "5000px",
  backgroundColor: "$decorativeBrandPrimaryPastel"
};
var PageHeaderBackground2 = (_a) => {
  var _b = _a, {
    height = DEFAULT_STYLES.height,
    pageHeaderBackgroundHeight = DEFAULT_STYLES.height,
    pageHeaderBackgroundColor,
    backgroundImage,
    curved,
    image,
    imageAltText
  } = _b, rest = __objRest(_b, [
    "height",
    "pageHeaderBackgroundHeight",
    "pageHeaderBackgroundColor",
    "backgroundImage",
    "curved",
    "image",
    "imageAltText"
  ]);
  var _a2, _b2;
  const [uiConfig] = useUiConfig();
  const theme = useTheme();
  const pageHeaderConfig = (_a2 = uiConfig.components) == null ? void 0 : _a2.pageHeader;
  const pageHeaderBackgroundColorCoreToken = (pageHeaderConfig == null ? void 0 : pageHeaderConfig.backgroundColor) && get(theme, pageHeaderConfig == null ? void 0 : pageHeaderConfig.backgroundColor);
  const isCurved = curved !== void 0 ? curved : (pageHeaderConfig == null ? void 0 : pageHeaderConfig.shape) !== "line";
  return /* @__PURE__ */ React19.createElement(
    StackItem3,
    __spreadValues({
      css: {
        height,
        backgroundColor: "transparent",
        marginTop: "$oneAndHalf",
        marginBottom: "$twoAndHalf",
        "@laptop": {
          marginTop: "56px",
          marginBottom: "56px"
        },
        "@desktop": {
          marginTop: "56px",
          marginBottom: "56px"
        },
        "&:before": {
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : `unset`,
          backgroundSize: "auto",
          backgroundRepeat: "no-repeat",
          backgroundColor: `${(_b2 = pageHeaderBackgroundColor != null ? pageHeaderBackgroundColor : pageHeaderBackgroundColorCoreToken) != null ? _b2 : DEFAULT_STYLES.backgroundColor}`,
          content: '""',
          zIndex: "0",
          position: "absolute",
          backgroundPosition: `bottom calc(0px - 5px) left calc(100% - ${DEFAULT_STYLES.width}/2 + 50vw)`,
          width: `${DEFAULT_STYLES.width}`,
          height: `${DEFAULT_STYLES.width}`,
          left: `calc(50% - (${DEFAULT_STYLES.width} / 2))`,
          top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.width})`,
          borderRadius: `${isCurved ? DEFAULT_STYLES.width : 0}`,
          "@mobile": {
            backgroundPosition: `bottom calc(0px - 5px) left calc(100% - ${DEFAULT_STYLES.smallScreenWidth}/2 + 50vw)`,
            top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.smallScreenWidth})`,
            left: `calc(50% - (${DEFAULT_STYLES.smallScreenWidth} / 2))`,
            width: `${DEFAULT_STYLES.smallScreenWidth}`,
            height: `${DEFAULT_STYLES.smallScreenWidth}`,
            borderRadius: `${isCurved ? DEFAULT_STYLES.smallScreenWidth : 0}`
          },
          "@mobileLandscape": {
            backgroundPosition: `bottom calc(0px - 5px) left calc(100% - ${DEFAULT_STYLES.smallScreenWidth}/2 + 50vw)`,
            top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.smallScreenWidth})`,
            left: `calc(50% - (${DEFAULT_STYLES.smallScreenWidth} / 2))`,
            width: `${DEFAULT_STYLES.smallScreenWidth}`,
            height: `${DEFAULT_STYLES.smallScreenWidth}`,
            borderRadius: `${isCurved ? DEFAULT_STYLES.smallScreenWidth : 0}`
          }
        }
      }
    }, rest)
  );
};

// src/components/hero-banner/hero-banner.component.tsx
import { InternalOrExternalLinkButton as InternalOrExternalLinkButton2 } from "@leagueplatform/web-common-components";
var DecorativeIcon = styled("img", {
  width: "100%",
  height: "100%",
  objectFit: "cover"
});
var HeroBanner = ({
  heading,
  body,
  eyebrow,
  buttonLabel,
  buttonAction = "",
  image,
  imageAltText = "",
  icon,
  backgroundColor,
  curved,
  includeSafeArea = false,
  onCardClick: onButtonClick
}) => {
  const contentRef = useRef5(null);
  const [contentHeight, setContentHeight] = useState(150);
  const isLaptopDown = useMediaQuery3(queryHelpers3.down("laptop"));
  const pageHeaderBackgroundHeightPadding = isLaptopDown ? 60 : 112;
  useLayoutEffect(() => {
    const reportWindowSize = () => {
      var _a, _b;
      setContentHeight((_b = (_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight) != null ? _b : contentHeight);
    };
    if (contentHeight !== void 0)
      window.addEventListener("resize", reportWindowSize);
    return () => window.removeEventListener("resize", reportWindowSize);
  }, [contentHeight]);
  useEffect(() => {
    var _a;
    if ((_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight)
      setContentHeight(contentRef.current.clientHeight);
  }, []);
  return /* @__PURE__ */ React20.createElement(
    PageHeaderBackground2,
    {
      height: `${contentHeight + pageHeaderBackgroundHeightPadding / 2}px`,
      pageHeaderBackgroundHeight: `${contentHeight + pageHeaderBackgroundHeightPadding}px`,
      pageHeaderBackgroundColor: backgroundColor,
      backgroundImage: image,
      curved,
      image,
      imageAltText
    },
    /* @__PURE__ */ React20.createElement(
      StackLayout14,
      {
        orientation: "horizontal",
        spacing: "$one",
        horizontalAlignment: "start",
        verticalAlignment: "top",
        css: { position: "relative" }
      },
      /* @__PURE__ */ React20.createElement(
        StackItem4,
        {
          horizontalAlignment: "start",
          css: {
            marginRight: includeSafeArea ? "160px" : "none"
          },
          verticalAlignment: "top",
          ref: contentRef
        },
        /* @__PURE__ */ React20.createElement(
          StackLayout14,
          {
            orientation: "horizontal",
            spacing: "$oneAndHalf",
            horizontalAlignment: "start",
            verticalAlignment: "top"
          },
          icon && /* @__PURE__ */ React20.createElement(
            StackItem4,
            {
              css: {
                flex: "1 1 100%",
                overflow: "hidden",
                aspectRatio: "1 / 1",
                maxWidth: "64px",
                "@mobile": {
                  order: 2
                },
                "@laptop": {
                  maxWidth: "80px"
                },
                "@desktop": {
                  maxWidth: "96px"
                }
              }
            },
            /* @__PURE__ */ React20.createElement(DecorativeIcon, { src: icon, alt: "", "data-testid": "hero-icon" })
          ),
          /* @__PURE__ */ React20.createElement(StackItem4, { horizontalAlignment: "start", verticalAlignment: "top" }, eyebrow && /* @__PURE__ */ React20.createElement(UtilityText4, { size: "eyebrow" }, eyebrow), /* @__PURE__ */ React20.createElement(
            HeadingText4,
            {
              level: "1",
              size: {
                "@initial": "xl",
                "@laptop": "xxl",
                "@desktop": "xxl"
              },
              css: {
                marginTop: "$quarter"
              }
            },
            heading
          ), body && /* @__PURE__ */ React20.createElement(
            ParagraphText8,
            {
              htmlStringOptions: BodyTextHtmlTagOptions,
              css: {
                typography: "$bodyTwo",
                marginTop: "$threeQuarters",
                color: "$onSurfaceTextPrimary",
                "@laptop": {
                  typography: "$bodyOne"
                },
                "@desktop": {
                  typography: "$bodyOne"
                }
              }
            },
            body
          ), buttonLabel && /* @__PURE__ */ React20.createElement(
            InternalOrExternalLinkButton2,
            {
              size: "medium",
              priority: "primary",
              type: "button",
              onClick: onButtonClick,
              href: normalizeInternalUrl(buttonAction),
              css: {
                marginTop: "$one"
              }
            },
            buttonLabel
          ), image && /* @__PURE__ */ React20.createElement(
            VisuallyHidden,
            {
              "data-testid": "hero-img",
              role: "img",
              "aria-label": imageAltText
            }
          ))
        )
      )
    )
  );
};

// src/components/progress-ring-card-widget/progress-ring-card-widget.component.tsx
import React21, { useRef as useRef6 } from "react";
import { Box as Box7, useTheme as useTheme2 } from "@leagueplatform/genesis-commons";
import {
  ProgressRing,
  ConditionalLinkCard as ConditionalLinkCard6,
  ConditionalLink as ConditionalLink5
} from "@leagueplatform/web-common-components";
import {
  HeadingText as HeadingText5,
  ParagraphText as ParagraphText9,
  UtilityText as UtilityText5,
  StackLayout as StackLayout15
} from "@leagueplatform/genesis-core";
var PROGRESS_RING_DIMENSION = 82;
var ProgressRingCardWidget = ({
  heading,
  eyebrow,
  currentText,
  suffixText = "",
  footerText,
  image,
  imageAltText,
  progress,
  action,
  emphasizeCurrentValue = false,
  onCardClick = () => {
  }
}) => {
  const { space } = useTheme2();
  const linkRefState = useRef6(null);
  return /* @__PURE__ */ React21.createElement(StackLayout15, { horizontalAlignment: "stretch" }, /* @__PURE__ */ React21.createElement(
    ConditionalLinkCard6,
    {
      linkRef: linkRefState,
      hasLink: Boolean(action),
      cardStyle: {
        flexDirection: "column",
        padding: "oneAndHalf",
        alignItems: "center",
        boxShadow: "card",
        borderRadius: "large",
        backgroundColor: "surface.background.primary",
        marginTop: `calc(${PROGRESS_RING_DIMENSION}px/2)`
      }
    },
    /* @__PURE__ */ React21.createElement(
      Box7,
      {
        width: PROGRESS_RING_DIMENSION,
        height: PROGRESS_RING_DIMENSION,
        position: "relative",
        transform: `translateY(calc(-50% - ${space.oneAndHalf}px))`,
        marginBottom: `calc(-${PROGRESS_RING_DIMENSION}px/2 - ${space.oneAndHalf}px + ${space.threeQuarters}px)`
      },
      /* @__PURE__ */ React21.createElement(
        ProgressRing,
        {
          size: PROGRESS_RING_DIMENSION,
          total: 100,
          current: progress,
          customRingFillColor: "success.border.default",
          customRingBackgroundColor: "success.background.subdued",
          screenReaderText: `${currentText} ${suffixText || ""}`,
          image,
          imageAltText
        }
      )
    ),
    /* @__PURE__ */ React21.createElement(
      StackLayout15,
      {
        spacing: "$threeQuarters",
        horizontalAlignment: "center",
        css: { width: "100%", textAlign: "center" }
      },
      eyebrow && /* @__PURE__ */ React21.createElement(
        UtilityText5,
        {
          css: {
            color: "$onSurfaceTextSubdued"
          },
          size: "eyebrow"
        },
        eyebrow
      ),
      heading && /* @__PURE__ */ React21.createElement(
        HeadingText5,
        {
          level: "display",
          css: { marginTop: "$quarter !important" },
          size: "sm"
        },
        heading
      ),
      /* @__PURE__ */ React21.createElement(ParagraphText9, { as: "h3", size: "sm" }, /* @__PURE__ */ React21.createElement(
        ConditionalLink5,
        {
          ref: linkRefState,
          url: action,
          onClick: onCardClick
        },
        /* @__PURE__ */ React21.createElement(
          ParagraphText9,
          {
            as: "span",
            size: "sm",
            css: {
              fontWeight: emphasizeCurrentValue ? "bold" : "400"
            }
          },
          currentText
        ),
        " ",
        suffixText
      )),
      footerText && /* @__PURE__ */ React21.createElement(ParagraphText9, { size: "xs", css: { color: "$onSurfaceTextSubdued" } }, footerText)
    )
  ));
};

// src/components/section-header/section-header.component.tsx
import * as React22 from "react";
import { HeadingText as HeadingText6 } from "@leagueplatform/genesis-core";
var SectionHeader = ({
  heading,
  paddingTop = "$one"
}) => /* @__PURE__ */ React22.createElement(
  HeadingText6,
  {
    size: "xl",
    level: "2",
    css: {
      paddingTop
    }
  },
  heading
);

// src/components/carousel-widget/carousel-widget.component.tsx
import React23 from "react";
import { Box as Box8 } from "@leagueplatform/genesis-commons";
import { Carousel } from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText10 } from "@leagueplatform/genesis-core";
var CarouselWidget = ({
  title,
  description,
  headerLinkHint,
  headerLinkUrl,
  items,
  onScrollLeft,
  onScrollRight,
  onSelectItem,
  onSelectHeader
}) => /* @__PURE__ */ React23.createElement(Box8, { paddingTop: "one", width: "100%" }, /* @__PURE__ */ React23.createElement(
  Carousel,
  {
    name: title || "Content Cards",
    heading: title ? /* @__PURE__ */ React23.createElement(SectionHeader, { heading: title, paddingTop: "$none" }) : void 0,
    description: /* @__PURE__ */ React23.createElement(ParagraphText10, { htmlStringOptions: BodyTextHtmlTagOptions }, description),
    spaceBetweenCards: "oneAndHalf",
    linkCta: headerLinkHint,
    linkUrl: headerLinkUrl,
    linkOnClick: onSelectHeader,
    LeftNavButtonAnalyticsFn: onScrollLeft,
    RightNavButtonAnalyticsFn: onScrollRight
  },
  items.map((item, index) => /* @__PURE__ */ React23.createElement(
    CarouselContentCardWidget,
    {
      key: item.title,
      title: item.title,
      image: item.image,
      imageAltText: item.imageAltText,
      linkUrl: item.linkUrl,
      overline: item.overline,
      description: item.description,
      badge: item.badge,
      badgeImage: item.badgeImage,
      onClick: () => {
        onSelectItem(item, index);
      }
    }
  ))
));

// src/components/generic-carousel-widget/generic-carousel-widget.component.tsx
import React24 from "react";
import { Carousel as Carousel2 } from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText11, Box as Box9 } from "@leagueplatform/genesis-core";
var GenericCarouselWidget = ({
  heading,
  body,
  headerButtonLabel,
  headerButtonAction,
  children,
  onScrollLeft,
  onScrollRight,
  onSelectHeader
}) => /* @__PURE__ */ React24.createElement(
  Box9,
  {
    css: {
      paddingTop: "$one"
    }
  },
  /* @__PURE__ */ React24.createElement(
    Carousel2,
    {
      name: heading || "Content Cards",
      heading: heading ? /* @__PURE__ */ React24.createElement(SectionHeader, { heading, paddingTop: "$none" }) : void 0,
      description: /* @__PURE__ */ React24.createElement(ParagraphText11, { htmlStringOptions: BodyTextHtmlTagOptions }, body),
      spaceBetweenCards: "oneAndHalf",
      linkCta: headerButtonLabel,
      linkUrl: headerButtonAction,
      linkOnClick: onSelectHeader,
      LeftNavButtonAnalyticsFn: onScrollLeft,
      RightNavButtonAnalyticsFn: onScrollRight
    },
    children
  )
);

// src/components/progress-bar-card-widget/progress-bar-card-widget.component.tsx
import React26, { useRef as useRef7 } from "react";
import { ConditionalLinkCard as ConditionalLinkCard7 } from "@leagueplatform/web-common-components";

// src/components/progress-bar-card-widget/progress-bar-card-content.component.tsx
import React25 from "react";
import { Box as Box10, Overline as Overline3 } from "@leagueplatform/genesis-commons";
import {
  ProgressBar,
  ConditionalLink as ConditionalLink6
} from "@leagueplatform/web-common-components";
import {
  HeadingText as HeadingText7,
  ParagraphText as ParagraphText12,
  StackLayout as StackLayout16,
  UtilityText as UtilityText6
} from "@leagueplatform/genesis-core";
var ProgressBarCardContent = ({
  eyebrow,
  heading,
  currentText,
  progress,
  suffixText,
  footerText,
  action,
  linkRefState,
  emphasizeCurrentValue = false,
  onCardClick
}) => /* @__PURE__ */ React25.createElement(
  StackLayout16,
  {
    orientation: "vertical",
    spacing: "$quarter",
    css: { margin: "$oneAndHalf", alignItems: "normal", height: "auto" }
  },
  eyebrow && /* @__PURE__ */ React25.createElement(Overline3, { as: "p", color: "onSurface.text.subdued", marginBottom: "quarter" }, eyebrow),
  /* @__PURE__ */ React25.createElement(StackLayout16, { spacing: "$threeQuarters", orientation: "vertical" }, heading && /* @__PURE__ */ React25.createElement(HeadingText7, { level: "display", size: "sm" }, heading), /* @__PURE__ */ React25.createElement(ParagraphText12, { size: "sm", as: "h3" }, /* @__PURE__ */ React25.createElement(ConditionalLink6, { ref: linkRefState, url: action, onClick: onCardClick }, /* @__PURE__ */ React25.createElement(
    ParagraphText12,
    {
      as: "span",
      size: "sm",
      css: {
        fontWeight: emphasizeCurrentValue ? "bold" : "400"
      }
    },
    currentText
  ), " ", suffixText)), /* @__PURE__ */ React25.createElement(Box10, { paddingBottom: "half", width: "100%" }, /* @__PURE__ */ React25.createElement(
    ProgressBar,
    {
      total: 100,
      current: progress,
      customBarFillColor: "success.border.default",
      customBarBackgroundColor: "success.background.subdued",
      screenReaderText: `${currentText} ${suffixText}`
    }
  )), /* @__PURE__ */ React25.createElement(
    UtilityText6,
    {
      emphasis: "subtle",
      size: "xs",
      css: {
        alignSelf: "flex-end"
      }
    },
    footerText
  ))
);

// src/components/progress-bar-card-widget/progress-bar-card-widget.component.tsx
var ProgressBarCardWithoutImage = ({
  eyebrow,
  heading,
  currentText,
  progress,
  suffixText,
  footerText,
  action,
  linkRefState,
  onCardClick
}) => /* @__PURE__ */ React26.createElement(
  ProgressBarCardContent,
  {
    eyebrow,
    heading,
    currentText,
    progress,
    suffixText,
    footerText,
    linkRefState,
    action,
    onCardClick
  }
);
var ProgressBarCardWithImage = ({
  eyebrow,
  heading,
  image,
  imageAltText = "",
  currentText,
  progress,
  suffixText,
  footerText,
  action,
  isChildItem = false,
  emphasizeCurrentValue,
  linkRefState,
  onCardClick
}) => /* @__PURE__ */ React26.createElement(
  LargeImageCard,
  {
    image,
    imageAltText,
    isChildItem
  },
  /* @__PURE__ */ React26.createElement(
    ProgressBarCardContent,
    {
      eyebrow,
      heading,
      currentText,
      progress,
      suffixText,
      footerText,
      linkRefState,
      emphasizeCurrentValue,
      action,
      onCardClick
    }
  )
);
var ProgressBarCardWidget = (_a) => {
  var props = __objRest(_a, []);
  const { image, action } = props;
  const linkRefState = useRef7(null);
  return /* @__PURE__ */ React26.createElement(ConditionalLinkCard7, { linkRef: linkRefState, hasLink: Boolean(action) }, image ? /* @__PURE__ */ React26.createElement(
    ProgressBarCardWithImage,
    __spreadValues({
      image,
      linkRefState
    }, props)
  ) : /* @__PURE__ */ React26.createElement(
    ProgressBarCardWithoutImage,
    __spreadValues({
      linkRefState,
      action
    }, props)
  ));
};

// src/components/two-up-card-content/two-up-card-content.component.tsx
import React27, { useRef as useRef8 } from "react";
import {
  HeadingThree as HeadingThree5,
  Image as Image5,
  SubtitleOne as SubtitleOne5
} from "@leagueplatform/genesis-commons";
import {
  ConditionalLink as ConditionalLink7,
  ConditionalLinkCard as ConditionalLinkCard8,
  StackLayout as StackLayout17
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText13 } from "@leagueplatform/genesis-core";
var TwoUpCardContent = ({
  heading,
  body,
  imageAltText,
  image,
  actionLink,
  onClick = () => {
  }
}) => {
  const linkRef = useRef8(null);
  return /* @__PURE__ */ React27.createElement(
    ConditionalLinkCard8,
    {
      linkRef,
      hasLink: Boolean(actionLink),
      cardStyle: {
        padding: "oneAndHalf",
        width: "100%"
      }
    },
    /* @__PURE__ */ React27.createElement(StackLayout17, { space: "$half" }, /* @__PURE__ */ React27.createElement(
      Image5,
      {
        borderRadius: "medium",
        src: image,
        alt: imageAltText,
        height: "4.2rem",
        width: "4.2rem"
      }
    ), /* @__PURE__ */ React27.createElement(StackLayout17, { space: "$quarter" }, /* @__PURE__ */ React27.createElement(SubtitleOne5, { as: HeadingThree5, fontWeight: "bold" }, /* @__PURE__ */ React27.createElement(ConditionalLink7, { onClick, ref: linkRef, url: actionLink }, heading)), body && /* @__PURE__ */ React27.createElement(ParagraphText13, { htmlStringOptions: BodyTextHtmlTagOptions }, body)))
  );
};

// src/components/two-up-card-widget/two-up-card-widget.component.tsx
import React28 from "react";
import { Flex as Flex5, css as css4, genesisStyled as genesisStyled5 } from "@leagueplatform/genesis-commons";
var StyledFlex = genesisStyled5(Flex5)(
  css4({
    justifyContent: "space-between",
    "&& > * + *": {
      marginLeft: "one"
    }
  })
);
var StyledLi = genesisStyled5("li")(
  css4({
    width: "100%",
    display: "flex",
    flexDirection: "row"
  })
);
var TwoUpCardWidget = ({
  items,
  onItemClick
}) => /* @__PURE__ */ React28.createElement(StyledFlex, { as: "ul" }, items.map((card, index) => {
  const { heading, body, image, imageAltText, actionLink } = card;
  return /* @__PURE__ */ React28.createElement(StyledLi, { key: heading }, /* @__PURE__ */ React28.createElement(
    TwoUpCardContent,
    {
      heading,
      body,
      image,
      imageAltText,
      actionLink,
      onClick: () => onItemClick(card, index)
    }
  ));
}));

// src/components/stack-widget-wrapper/stack-widget-wrapper.component.tsx
import * as React30 from "react";
import { StackLayout as StackLayout18 } from "@leagueplatform/genesis-core";

// src/components/grid-container/grid-container.tsx
import { Box as Box11 } from "@leagueplatform/genesis-core";
import * as React29 from "react";
var DEFAULT_STYLES2 = {
  MIN_GRID_ITEM_WIDTH: "250px",
  GRID_COLUMN_COUNT: 2
};
function GridContainer({
  gridColumnCount = DEFAULT_STYLES2.GRID_COLUMN_COUNT,
  minGridItemWidth = DEFAULT_STYLES2.MIN_GRID_ITEM_WIDTH,
  children
}) {
  const gapCount = gridColumnCount - 1;
  const totalGapWidth = gapCount * 16;
  const maxGridItemWidth = `calc((100% - ${totalGapWidth}px) / ${gridColumnCount})`;
  return /* @__PURE__ */ React29.createElement(
    Box11,
    {
      css: {
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(max(${minGridItemWidth}, ${maxGridItemWidth}), 1fr));`,
        gridGap: "$one"
      }
    },
    children
  );
}

// src/components/stack-widget-wrapper/stack-widget-wrapper.component.tsx
function StackOrGrid({
  gridColumnCount,
  orientation,
  children
}) {
  if (orientation === "grid") {
    return /* @__PURE__ */ React30.createElement(GridContainer, { gridColumnCount }, children);
  }
  return /* @__PURE__ */ React30.createElement(
    StackLayout18,
    {
      spacing: "$one",
      horizontalAlignment: "stretch",
      verticalAlignment: "stretch",
      orientation
    },
    children
  );
}
var StackWidgetWrapper = ({
  gridColumnCount,
  heading,
  orientation,
  children
}) => {
  if (!children)
    return null;
  return /* @__PURE__ */ React30.createElement(
    StackLayout18,
    {
      spacing: "$one",
      orientation: "vertical",
      horizontalAlignment: "stretch"
    },
    heading && /* @__PURE__ */ React30.createElement(SectionHeader, { heading }),
    /* @__PURE__ */ React30.createElement(StackOrGrid, { orientation, gridColumnCount }, children)
  );
};

// src/components/error-page/error-page.component.tsx
import React31 from "react";
import {
  Box as Box12
} from "@leagueplatform/genesis-commons";
import { ErrorState } from "@leagueplatform/web-common-components";
import { handleStaticAsset } from "@leagueplatform/asset-config";

// src/hooks/use-error-message.hook.ts
var ERROR_TYPES = /* @__PURE__ */ ((ERROR_TYPES3) => {
  ERROR_TYPES3["API_ERROR"] = "api_error";
  ERROR_TYPES3["NO_CONNECTION"] = "no_connection";
  return ERROR_TYPES3;
})(ERROR_TYPES || {});
var defaultTryAgainHandler = () => window.location.reload();
var useErrorMessage = (errorType) => {
  const ErrorMessages = {
    ["api_error" /* API_ERROR */]: {
      headingId: "ERROR_HEADING_GENERIC",
      bodyId: "ERROR_CAPTION_BACKEND",
      buttonAction: defaultTryAgainHandler
    },
    ["no_connection" /* NO_CONNECTION */]: {
      headingId: "ERROR_HEADING_NO_CONNECTION",
      bodyId: "ERROR_CAPTION_NO_CONNECTION",
      hideButton: true
    }
  };
  return ErrorMessages[errorType];
};

// src/components/error-page/error-page.component.tsx
var FullScreenContainer = ({
  backgroundColor,
  children,
  labelledbyId,
  describedbyId: describedbyId2
}) => /* @__PURE__ */ React31.createElement(
  Box12,
  {
    role: "dialog",
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "100",
    backgroundColor,
    "aria-labelledby": labelledbyId,
    "aria-describedby": describedbyId2
  },
  children
);
var LabelledbyId = "full-page-error-heading";
var describedbyId = "full-page-error-desc";
var ErrorPage = ({ errorType }) => {
  const { headingId, bodyId, buttonId, onButtonClick, hideButton } = useErrorMessage(errorType);
  const imageSrc = handleStaticAsset("ERROR_STATE_COVER");
  return /* @__PURE__ */ React31.createElement(
    FullScreenContainer,
    {
      labelledbyId: LabelledbyId,
      describedbyId,
      backgroundColor: "surface.background.primary"
    },
    /* @__PURE__ */ React31.createElement(
      Box12,
      {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      },
      /* @__PURE__ */ React31.createElement(
        ErrorState,
        {
          imageSrc,
          headingId,
          bodyId,
          buttonId,
          hideButton,
          onButtonClick,
          labelledbyId: LabelledbyId,
          describedbyId
        }
      )
    )
  );
};

// src/components/skeletons/extra-small-skeleton.component.tsx
import { SkeletonRectangle } from "@leagueplatform/genesis-core";
import React32 from "react";
var ExtraSmallSkeleton = () => /* @__PURE__ */ React32.createElement(SkeletonRectangle, { height: 96 });

// src/components/skeletons/small-skeleton.component.tsx
import { Box as Box13, SkeletonRectangle as SkeletonRectangle2 } from "@leagueplatform/genesis-core";
import React33 from "react";
var SmallSkeleton = () => /* @__PURE__ */ React33.createElement(Box13, { "aria-busy": true, "aria-live": "polite" }, /* @__PURE__ */ React33.createElement(
  SkeletonRectangle2,
  {
    height: {
      "@initial": "160px",
      "@mobile": "180px"
    }
  }
));

// src/components/skeletons/large-skeleton.component.tsx
import { SkeletonRectangle as SkeletonRectangle3 } from "@leagueplatform/genesis-core";
import React34 from "react";
var LargeSkeleton = () => /* @__PURE__ */ React34.createElement(
  SkeletonRectangle3,
  {
    height: {
      "@initial": "196px",
      "@tablet": "220px",
      "@mobileLandscape": "220px",
      "@mobile": "396px"
    }
  }
);

// src/components/skeletons/hero-banner-skeleton.component.tsx
import {
  Box as Box14,
  SkeletonRectangle as SkeletonRectangle4,
  StackLayout as StackLayout19
} from "@leagueplatform/genesis-core";
import React35 from "react";
var HeroBannerSkeleton = () => /* @__PURE__ */ React35.createElement(
  Box14,
  {
    css: {
      height: "184px",
      "@tablet": {
        height: "232px"
      },
      "@mobileLandscape": {
        height: "232px"
      },
      "@laptop": {
        height: "351px"
      },
      "@desktop": {
        height: "351px"
      }
    }
  },
  /* @__PURE__ */ React35.createElement(
    StackLayout19,
    {
      css: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        paddingBlock: "$twoAndHalf",
        paddingInline: "$three",
        "@mobile": {
          paddingBlock: "$oneAndHalf",
          paddingInline: "$oneAndHalf"
        },
        backgroundColor: "$decorativeBrandPrimaryPastel"
      }
    },
    /* @__PURE__ */ React35.createElement(
      SkeletonRectangle4,
      {
        height: {
          "@initial": "136px",
          "@laptop": "255px",
          "@desktop": "255px"
        }
      }
    )
  )
);

// src/components/metric-card-widget/metric-card-widget.component.tsx
import * as React36 from "react";
import {
  HeadingText as HeadingText8,
  Icon as Icon3,
  ParagraphText as ParagraphText14,
  StackLayout as StackLayout20,
  styled as styled2,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import { HtmlToReact } from "@leagueplatform/web-common";
import {
  ConditionalLink as ConditionalLink8,
  ConditionalLinkCard as ConditionalLinkCard9
} from "@leagueplatform/web-common-components";
var StyledImage2 = styled2("img", {
  contentFit: "cover",
  contentPosition: "center",
  width: "$three",
  height: "$three"
});
function MetricCardWidget({
  action,
  heading,
  measurements,
  body,
  timestamp,
  image,
  imageAltText,
  onCardClick
}) {
  const linkRef = React36.useRef(null);
  const displayMeasurements = !!(measurements == null ? void 0 : measurements.length);
  const displayBody = !displayMeasurements && !!body;
  return /* @__PURE__ */ React36.createElement(
    ConditionalLinkCard9,
    {
      linkRef,
      hasLink: Boolean(action),
      cardStyle: {
        flexWrap: "wrap",
        justifyContent: "space-between",
        padding: "oneAndHalf"
      }
    },
    /* @__PURE__ */ React36.createElement(
      StackLayout20,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$threeQuarters"
      },
      image && /* @__PURE__ */ React36.createElement(StyledImage2, { src: image, alt: imageAltText }),
      /* @__PURE__ */ React36.createElement(
        StackLayout20,
        {
          css: {
            width: "100%"
          },
          orientation: "horizontal",
          horizontalAlignment: "spaceBetween"
        },
        /* @__PURE__ */ React36.createElement(
          StackLayout20,
          {
            css: {
              width: "100%"
            },
            spacing: "$quarter",
            verticalAlignment: "spaceBetween"
          },
          /* @__PURE__ */ React36.createElement(HeadingText8, { size: "sm", level: "3", color: "$onSurfaceTextPrimary" }, /* @__PURE__ */ React36.createElement(ConditionalLink8, { ref: linkRef, url: action, onClick: onCardClick }, heading)),
          displayMeasurements ? /* @__PURE__ */ React36.createElement(StackLayout20, { orientation: "horizontal" }, /* @__PURE__ */ React36.createElement(
            ParagraphText14,
            {
              "data-testId": "measurement",
              css: {
                marginRight: "$threeQuarters",
                width: "100%",
                "&&": {
                  marginBlockEnd: "$none"
                }
              }
            },
            measurements.map(({ value, unit }) => /* @__PURE__ */ React36.createElement(React36.Fragment, { key: `${value}${unit}` }, /* @__PURE__ */ React36.createElement(
              UtilityText7,
              {
                css: {
                  paddingRight: "$quarter",
                  typography: "$headingThree"
                }
              },
              value
            ), unit && /* @__PURE__ */ React36.createElement(
              UtilityText7,
              {
                css: {
                  typography: "$label",
                  color: "$onSurfaceTextSubdued",
                  paddingRight: "$quarter"
                }
              },
              unit,
              " "
            )))
          )) : null,
          displayBody ? /* @__PURE__ */ React36.createElement(
            UtilityText7,
            {
              css: {
                typography: "$caption",
                color: "$onSurfaceTextSubdued"
              }
            },
            /* @__PURE__ */ React36.createElement(HtmlToReact, { htmlString: body })
          ) : null
        ),
        timestamp && /* @__PURE__ */ React36.createElement(
          ParagraphText14,
          {
            css: {
              typography: "$label",
              color: "$onSurfaceTextSubdued"
            }
          },
          timestamp
        )
      ),
      action ? /* @__PURE__ */ React36.createElement(
        Icon3,
        {
          size: 24,
          icon: "interfaceChevronRight",
          tint: "$onSurfaceIconPrimary"
        }
      ) : null
    )
  );
}

// src/index.ts
initModule();
export {
  CAROUSEL_CONTENT_CARD_WIDTH,
  COMPLEX_WIDGET_CARDS_WIDTH,
  CarouselContentCardWidget,
  CarouselWidget,
  ERROR_TYPES,
  ErrorPage,
  ExtraSmallSkeleton,
  GenericCarouselWidget,
  HeroBanner,
  HeroBannerSkeleton,
  ImageFooter,
  LargeSkeleton,
  LargeVisualCardWidget,
  MetricCardWidget,
  NotificationBannerWidget,
  NotificationCardWidget,
  ProgressBarCardWidget,
  ProgressRingCardWidget,
  SectionHeader,
  SmallSkeleton,
  SmallVisualCardWidget,
  StackWidgetWrapper,
  TextAndCTACardWidget,
  TwoUpCardContent,
  TwoUpCardWidget,
  WelcomeBanner,
  XSVisualCardWidget
};
//# sourceMappingURL=index.js.map